<div data-testid="zone-tile">
    <div class="zone__top border-zone cursor-pointer"
         (click)="zones.goToMenu(tile)">
        <floating-subtitle class="zone__name zone__name--valve font-21"
                           [text]="subtitle(128)">
        </floating-subtitle>
        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24 ">
            <p class="zone__set-temp font-bold" data-testid="set-temp">
                {{ tile.params.setTempDHW | format:7 }}
            </p>
        </div>
    </div>

    <div class="zone__status cursor-pointer">
        <div class="gradient-zone zone__status-background"
             data-testid="animation"
             [ngClass]="{ 'zone__status--animated': tile.params.isActive }"
             (click)="zones.goToMenu(tile)"
        ></div>
    </div>

    <div class="zone__content cursor-pointer"
         (click)="zones.goToMenu(tile)">
        <div class="zone__content-icon">
            <icon [iconName]="'DHW'"
                  data-testid="tile-icon-DHW"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'DHW'"
                  data-testid="tile-icon-DHW-mobile"
                  [iconSize]="views.isMobileView() ? 40 : 50"
                  [className]="'zone__icon zone__icon--dark  fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__current-temp" data-testid="tile-value">
            {{ tile.params.currentTempDHW | format:7 }}
        </div>
    </div>

    <div class="zone__container-tile--footer bg-style bg-gradient--zone">
        <div class="zone__icons zone__icons--dhw"></div>
    </div>

    <div class="zone__relay-status-mobile fill-style">
        <img class="zone__relay-status-img"
             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
             data-testid="relay-status-mobile-icon"
             [ngClass]="{ 'zone__relay-status-mobile--animated': tile.params.isActive }"
             width="25" height="25" alt=""/>
    </div>

    <div class="zone__alert zone__alert--tile bg-dark-shadow zone__alert--without-actuator cursor-pointer"
         *ngIf="tile.params.dhwSensorEvents.length > 0 || tile.params.heatingSensorEvents.length > 0"
         (click)="zones.goToMenu(tile)">
        <div class="zone__alert-multiline-wrapper">
            <div class="zone__alert-multiline-content" data-testid="events">
                <ng-container *ngIf="tile.params.dhwSensorEvents.length > 0">
                    <div class="zone__alert-event"
                         *ngFor="let event of tile.params.dhwSensorEvents">
                        {{ subtitle(event) }}
                    </div>
                </ng-container>
                <ng-container
                        *ngIf="tile.params.heatingSensorEvents.length > 0">
                    <div class="zone__alert-event"
                         *ngFor="let event of tile.params.heatingSensorEvents">
                        {{ subtitle(event) }}
                    </div>
                </ng-container>
            </div>
            <div class="zone__alert-multiline-icon">
                <svg width="50" height="50"
                     class="tile__svg--alarm-animation tile__svg--alarm-animation--right fill-alert ">
                    <text x="25" y="45" font-size="65" font-weight="bold"
                          text-anchor="middle">!
                    </text>
                </svg>
            </div>
        </div>
    </div>
</div>
